"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PopoverTrigger", {
    enumerable: true,
    get: function() {
        return PopoverTrigger;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _usePopoverTrigger = require("./usePopoverTrigger");
const _renderPopoverTrigger = require("./renderPopoverTrigger");
const PopoverTrigger = (props)=>{
    const state = (0, _usePopoverTrigger.usePopoverTrigger_unstable)(props);
    return (0, _renderPopoverTrigger.renderPopoverTrigger_unstable)(state);
};
PopoverTrigger.displayName = 'PopoverTrigger';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
PopoverTrigger.isFluentTriggerComponent = true;
